export const filtersKeys = [
  'tradeTime',
  'includedSubsectorIds',
  'includedIssuerIds',
  'size',
  'price',
  'coupon',
  'maturityDate',
  'includedContraPartyTypes',
  'includedRemunerations',
  'includedReportingPartyTypes',
  'includedReportingPartySides',
  'includedTradeStatuses',

  'tradeDate',
];

export const allowedToRemoveFilters = [
  'tradeTime',
  'includedSubsectorIds',
  'includedIssuerIds',
  'size',
  'price',
  'coupon',
  'maturityDate',
  'includedContraPartyTypes',
  'includedRemunerations',
  'includedReportingPartyTypes',
  'includedReportingPartySides',
  'includedTradeStatuses',

  'tradeDate',
];
